var React = require('react');

function PremiumGem (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","d":"M2.715 0L0 3.484h3.121L4.488 0H2.715zm2.731 0L4.075 3.484h4.45L7.154 0H5.446zm2.666 0l1.367 3.484H12.6L9.885 0H8.112zM.028 4.48l4.95 5.775-1.87-5.775H.027zm4.019 0L6.3 11.442 8.554 4.48H4.047zm5.446 0l-1.871 5.775 4.95-5.775h-3.08z"}));
}

PremiumGem.defaultProps = {"width":"13","height":"12"};

module.exports = PremiumGem;

PremiumGem.default = PremiumGem;
